module.exports = __webpack_public_path__ + "img/Moonbase_Browse.b542ab1c.png";